import React from 'react';
import Icon from '../../../components/AppIcon';

const LeadStatsCards = ({ leads }) => {
  const calculateStats = () => {
    const total = leads?.length;
    const newLeads = leads?.filter(lead => lead?.status === 'new')?.length;
    const qualifiedLeads = leads?.filter(lead => lead?.status === 'qualified')?.length;
    const closedWon = leads?.filter(lead => lead?.status === 'closed-won')?.length;
    const totalValue = leads?.reduce((sum, lead) => sum + (lead?.estimatedValue || 0), 0);
    const avgScore = total > 0 ? Math.round(leads?.reduce((sum, lead) => sum + lead?.score, 0) / total) : 0;
    const conversionRate = total > 0 ? Math.round((closedWon / total) * 100) : 0;

    return {
      total,
      newLeads,
      qualifiedLeads,
      closedWon,
      totalValue,
      avgScore,
      conversionRate
    };
  };

  const stats = calculateStats();

  const statCards = [
    {
      title: 'Total Leads',
      value: stats?.total?.toLocaleString(),
      icon: 'Users',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      change: '+12%',
      changeType: 'positive'
    },
    {
      title: 'New Leads',
      value: stats?.newLeads?.toLocaleString(),
      icon: 'UserPlus',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      change: '+8%',
      changeType: 'positive'
    },
    {
      title: 'Qualified Leads',
      value: stats?.qualifiedLeads?.toLocaleString(),
      icon: 'Target',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
      change: '+15%',
      changeType: 'positive'
    },
    {
      title: 'Closed Won',
      value: stats?.closedWon?.toLocaleString(),
      icon: 'Trophy',
      color: 'text-emerald-600',
      bgColor: 'bg-emerald-50',
      change: '+5%',
      changeType: 'positive'
    },
    {
      title: 'Pipeline Value',
      value: `$${stats?.totalValue?.toLocaleString()}`,
      icon: 'DollarSign',
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50',
      change: '+22%',
      changeType: 'positive'
    },
    {
      title: 'Avg Lead Score',
      value: stats?.avgScore,
      icon: 'BarChart3',
      color: 'text-indigo-600',
      bgColor: 'bg-indigo-50',
      change: '+3%',
      changeType: 'positive'
    },
    {
      title: 'Conversion Rate',
      value: `${stats?.conversionRate}%`,
      icon: 'TrendingUp',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      change: '-2%',
      changeType: 'negative'
    },
    {
      title: 'Active Campaigns',
      value: '8',
      icon: 'Send',
      color: 'text-pink-600',
      bgColor: 'bg-pink-50',
      change: '+1',
      changeType: 'positive'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-6 shadow-elevation-1 hover-elevation transition-all duration-200"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground mb-1">
                {stat?.title}
              </p>
              <p className="text-2xl font-bold text-foreground">
                {stat?.value}
              </p>
              <div className="flex items-center mt-2">
                <span className={`text-xs font-medium ${
                  stat?.changeType === 'positive' ? 'text-green-600' : 'text-red-600'
                }`}>
                  {stat?.change}
                </span>
                <span className="text-xs text-muted-foreground ml-1">
                  vs last month
                </span>
              </div>
            </div>
            <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LeadStatsCards;